import React from 'react';
import { Form } from './Form';
import { FormProvider } from '../context/FormContext';
const Powermail = ({ pages, afterSteps, activeStep, submitField, uid, action, values, errors }) => {
    var _a;
    return (React.createElement(FormProvider, { uid: uid },
        React.createElement(Form, { pages: JSON.parse(pages), activeStep: activeStep, afterSteps: JSON.parse(afterSteps), submitField: JSON.parse(submitField), action: action, values: JSON.parse(values), errors: (_a = JSON.parse(errors)) !== null && _a !== void 0 ? _a : {} })));
};
export default Powermail;
